import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import React from "react";
import { COLOR_PRIMARY } from "../../THEME";
import { pages, solutionOption } from "./constants";
import { textToVideoGenerationSettings, textToCreativesGeneratorSettings } from "./constants";

export const MobileViewMenu = ({ anchor, toggleDrawer, pathCheck }) => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    event.stopPropagation();
    event.preventDefault();
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role='presentation'
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <Accordion
          sx={{ boxShadow: "none" }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          disableGutters
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Use Cases</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ py: 0 }}>
            {textToVideoGenerationSettings &&
              textToVideoGenerationSettings.map((i) => (
                <React.Fragment key={i + +new Date()}>
                  {textToVideoGenerationSettings.map((el, j) => (
                    <React.Fragment key={j + +new Date()}>
                      <Typography
                        variant='h6'
                        sx={{ ml: "1rem", mb: ".25rem", fontSize: ".9rem", fontWeight: "600" }}
                        color={"black"}
                      >
                        Text To Video Generation
                      </Typography>
                      {el.subMenu.map((sb, k) => (
                        <ListItem disablePadding key={sb.linkURL + k}>
                          <ListItemButton sx={{ py: 0 }}>
                            <ListItemText
                              primary={
                                <Typography
                                  component='a'
                                  href={sb.linkURL}
                                  sx={{ fontSize: ".85rem" }}
                                >
                                  {sb.linkTitle}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            <Typography
              variant='h6'
              sx={{
                ml: "1rem",
                mt: ".5rem",
                mb: ".25rem",
                fontSize: ".9rem",
                fontWeight: "600"
              }}
              color={"black"}
            >
              Smart Copy Generation
            </Typography>
            <ListItem disablePadding>
              <ListItemButton sx={{ py: 0 }}>
                <ListItemText
                  primary={
                    <Typography
                      component='a'
                      href='https://predis.ai/social-media-ad-copy-generator/'
                      sx={{ fontSize: ".85rem" }}
                    >
                      Social Media Ad Copy
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            {textToCreativesGeneratorSettings &&
              textToCreativesGeneratorSettings.map((i) => (
                <React.Fragment key={i + +new Date()}>
                  {textToCreativesGeneratorSettings.map((el, j) => (
                    <React.Fragment key={j + +new Date()}>
                      <Typography
                        variant='h6'
                        sx={{
                          ml: "1rem",
                          mt: ".5rem",
                          mb: ".25rem",
                          fontSize: ".9rem",
                          fontWeight: "600"
                        }}
                        color={"black"}
                      >
                        Text to Creatives Generator
                      </Typography>
                      {el.subMenu.map((sb, k) => (
                        <ListItem disablePadding key={sb.linkURL + k}>
                          <ListItemButton sx={{ py: 0 }}>
                            <ListItemText
                              primary={
                                <Typography
                                  component='a'
                                  href={sb.linkURL}
                                  sx={{ fontSize: ".85rem" }}
                                >
                                  {sb.linkTitle}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            <Typography
              variant='h6'
              sx={{
                ml: "1rem",
                mt: ".5rem",
                mb: ".25rem",
                fontSize: ".9rem",
                fontWeight: "600"
              }}
              color={"black"}
            >
              Publish and Schedule
            </Typography>
            <ListItem disablePadding>
              <ListItemButton sx={{ py: 0 }}>
                <ListItemText
                  primary={
                    <Typography
                      component='a'
                      href='https://predis.ai/social-media-content-scheduling-tool/'
                      sx={{ fontSize: ".85rem" }}
                    >
                      Content Scheduler
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton sx={{ py: 0 }}>
                <ListItemText
                  primary={
                    <Typography
                      component='a'
                      href='https://predis.ai/use-cases/approval-flow/'
                      sx={{ fontSize: ".85rem" }}
                    >
                      Content Approval Flow
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            <Typography
              variant='h6'
              sx={{
                ml: "1rem",
                mt: ".5rem",
                mb: ".25rem",
                fontSize: ".9rem",
                fontWeight: "600"
              }}
              color={"black"}
            >
              Competitor Analysis
            </Typography>
            <ListItem disablePadding>
              <ListItemButton sx={{ py: 0 }}>
                <ListItemText
                  primary={
                    <Typography
                      component='a'
                      href='https://predis.ai/social-media-competitor-analysis/'
                      sx={{ fontSize: ".85rem" }}
                    >
                      Competitor Insights
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{ boxShadow: "none" }}
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          disableGutters
          className='solution-accordion'
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Solutions</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ py: 0 }}>
            {solutionOption.map((menu) => {
              return (
                <ListItem component='a' href={menu.link} key={menu.title} disablePadding>
                  <ListItemButton>
                    {/* <ListItemIcon sx={{ color: COLOR_PRIMARY, minWidth: "auto" }}>
                      {menu.icon}
                    </ListItemIcon> */}
                    <ListItemText
                      primary={
                        <Typography
                          component='a'
                          href={menu.link}
                          sx={{ fontSize: ".85rem", fontWeight: 300 }}
                        >
                          {menu.title}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </AccordionDetails>
        </Accordion>

        {pages.map((page) => (
          <ListItem component='a' href={page.link} key={page.title} disablePadding>
            <ListItemButton>
              <ListItemIcon sx={{ color: COLOR_PRIMARY, minWidth: "auto" }}>
                {page.icon}
              </ListItemIcon>
              <ListItemText primary={page.title} />
            </ListItemButton>
          </ListItem>
        ))}
        {!pathCheck && (
          <>
            <ListItem disablePadding component='a' href='https://predis.ai/pricing/'>
              <ListItemButton>
                {/* <ListItemIcon
                  component="a"
                  href="https://predis.ai/pricing/"
                  sx={{ color: COLOR_PRIMARY, minWidth: "auto" }}
                >
                  <AttachMoneyIcon sx={{ mr: ".5rem" }} />
                </ListItemIcon> */}
                <ListItemText primary='Pricing' />
              </ListItemButton>
            </ListItem>
            <ListItem component='a' href='https://app.predis.ai/' disablePadding>
              <ListItemButton>
                {/* <ListItemIcon sx={{ color: COLOR_PRIMARY, minWidth: "auto" }}>
                  <LoginIcon sx={{ mr: ".5rem" }} />
                </ListItemIcon> */}
                <ListItemText primary='Login' />
              </ListItemButton>
            </ListItem>
          </>
        )}
      </List>
    </Box>
  );
};
